import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/layout/Header';
import Home from './pages/Home';
import CEE from './pages/CEE';

const ScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && 'scrollTo' in location.state) {
      const elementId = location.state.scrollTo;
      const element = document.getElementById(elementId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      // Clear the state
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollHandler />
      <div className="min-h-screen bg-white">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cee" element={<CEE />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;